module.exports = __webpack_public_path__ + "static/media/paypal-word.091f0e09.svg";